import SignupProfileForm from '../../../../components/Auth/SignupProfile';
import './SignupProfileForm.css';
import './signupprofile.css';

const SignupProfilePage = () => {
    return (
        <div className="signupprofilePage">
            <SignupProfileForm />
        </div>
    );
};

export default SignupProfilePage;
